"use client";

import { BrandLogoMark } from "@v1/ui/brand-logo-mark";
import { ArrowLeft } from "lucide-react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import type { ReactElement } from "react";

/** Sticky slim top bar: logo left, one ghost back button to /careers. */
export function Engineering2Topbar(): ReactElement {
  const t = useTranslations("public.engineering2Topbar");
  return (
    <header className="dvf-bar">
      <div className="c2-bar-inner">
        <Link href="/" className="dvf-bar-logo">
          <BrandLogoMark width={24} height={24} variant="website" />
        </Link>

        <Link href="/careers" className="e2-bar-back">
          <ArrowLeft size={16} strokeWidth={2.2} aria-hidden={true} />
          <span>{t("careers")}</span>
        </Link>
      </div>
    </header>
  );
}
